/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PregnancyActionStatus {
    CESAREAN_SECTION = 'cesareanSection',
    INTERRUPTED_PREGNANCY = 'interruptedPregnancy',
    PREGNANT_PERSON = 'pregnantPerson',
    LOST_PREGNANCY = 'lostPregnancy',
    NATURAL_BIRTH = 'naturalBirth',
}
